import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cx-multi-step-checkout-page',
  templateUrl: './multi-step-checkout-page.component.html',
  styleUrls: ['./multi-step-checkout-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiStepCheckoutPageComponent {}
